import React, { useState, Component } from 'react';
import styled from "styled-components"
import { render } from 'react-dom';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import CalenderIcon from '../../../../assets/imgs/calendar-icon.png'

var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var date = new Date();
var tomorrow = new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1));


class Calender extends Component {
  state = {
   startDate: this.props.showRewardCalender?null:new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1)),
   minDate:  this.props.showRewardCalender?new Date(date.getFullYear(), date.getMonth(), (date.getDate())):new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1))
  };

  
 
  handleChange = date => {
    this.setState({
      startDate: date
    });
    //console.log("handleChange on DatePicker: ", this.state.startDate);
    // console.log(new Date())
    // console.log(tomorrow);
  };

  handleClick = () => {

    // console.log(this.state.startDate);
    let date = String(this.state.startDate);
    //console.log(typeof date);
    //console.log("date: ",date);
    // Sat Aug 01 2020 11:58:12 GMT+0530 (India Standard Time)

    //  date = date.substr(4, 11);
    //  console.log("date: ",date);

    let month = date.substring(4,7);
    // console.log(month);

    var val=months.indexOf(month)+1;
    if(val<10){
      month = '0'+val;
      // console.log(month);
    }else{
      month =val;
      // console.log(month);
    }

    date = date.substring(8,10) + "-" + month + "-" + date.substring(11,15);
   //console.log("date: ",date);


    // let inputString =   'Submit' + "<split>" + JSON.stringify(this.state.startDate);
    let inputString =   date + "<split>" + date;
    window['autosubmit'](inputString);

//    console.log("handleSubmit send to backend: ", date);

    document.getElementById("datepickerId").style.pointerEvents="none";

  }
 
  render() {
   // console.log(this.props.showRewardCalender)

    const MainBlock=styled.div`

   

    height:auto;
    margin-top: 10px;

    .datepicker-div{
      position: relative;
      width: 100%;
 
      z-index:100;
      opacity: 1;//here
   
    }

    .sf-datepicker{
   
    
      padding: 10px;
      color: #666666
      font-size:14px;
      cursor: pointer;
      width:92%;
      background: white;
      text-align:left !important;
      border: 1px solid #2c387a !important;
      border-radius: 5px !important;
      margin-bottom:5px !important;

    }

    .react-datepicker{
      font-size: 0.7em !important;
    }

    .react-datepicker__triangle{
      left:75px !important;
    }


    .react-datepicker-wrapper{
      width:100%
    }

    .react-datepicker-popper{
      width:330px !important;
   //   transform: translate(99px, 85px) scale(1.62) !important; //for main
   transform: translate(36px, 63px) scale(1.2) !important; //for main
    
    }

    @media(max-width : 400px){
      .react-datepicker-popper{
        width:330px !important;
       transform: translate(99px, 85px) scale(1.6) !important; //for main
   
    }
  
 
`
    return (
    
      <MainBlock >
        <div className="datepicker-div">
            <DatePicker className="sf-datepicker action-elem" id="datepickerId"
              
              selected={this.state.startDate}
              onChange={this.handleChange}
              dateFormat="dd-MM-yyyy" 
              // dateFormat="MMMM d, yyyy"
              // minDate={new Date()}
              // minDate = {new Date(date.getFullYear(), date.getMonth(), (date.getDate() + 1))}
              minDate = {this.state.minDate}
              placeholderText="Click to select date"
              autoComplete='off'
            />
  
        <div className="action-elem" style={{width: "92%", marginTop: "10px"}}
          onClick={this.handleClick}>Submit</div>
     
        </div>
      </MainBlock> 
    );
  }
} 


const ActionButton = styled.div`
    border: 0px solid #2c387a;
    border-radius: 6px;
    background: #2c387a;
    color: #fff;
    margin-top: 12px;s
`



export default Calender;